import {animated, useSpring} from "@react-spring/web";
import {LevelData} from "./models/levelData";
import {useApp} from "./appContext";

function RoomTile(params: { level: LevelData }) {
    const {setSelectedLevel} = useApp();

    const springs = useSpring({
        from: { x: -60, opacity: 0 },
        to: { x: 0, opacity: 1 },
    })

    return (
        <animated.div style={{
            position: 'relative',
            height: 300,
            backgroundColor: "var(--overlay-color)",
            borderRadius: 20,
            boxShadow: 'rgb(0 0 0 / 30%) 5px 5px 20px',
            overflow: 'hidden',
            cursor: 'pointer',
            ...springs
        }} onClick={() => setSelectedLevel(params.level)}>
            <div style={{
                position: 'absolute',
                bottom: 0,
                width: '100%',
                height: 80,
                backgroundImage: 'linear-gradient(0deg, rgb(0 0 0 / 70%), transparent)'
            }}/>
            <div style={{position: 'absolute', bottom: 0, padding: 'var(--box-padding)'}}>
                <p style={{fontSize: 'var(--font-size-title)', fontWeight: 'bold'}}>{params.level.name}</p>
            </div>
        </animated.div>
    )
}

export default RoomTile;
